import loadable from '@loadable/component';
import expertToplistQuery from './query.graphql';
import { getExcludeTypes } from '../utils/index';

const ExpertToplists = loadable(() =>
  import(/* webpackChunkName: "expert" */ './toplists')
);

ExpertToplists.graphQL = expertToplistQuery;

ExpertToplists.variables = ({ slug }) => ({
  slug,
  excludedTypes: getExcludeTypes(),
  variants: null,
  condition: 'new',
});

export default ExpertToplists;
